import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useFreecodeContextRun, useFreecodeContextData } from 'hooks/useContext';
import FreecodeCourseExpandingItem from './FreecodeCourseExpandingItem';
import { RoundIconButtonLink } from 'components/Button/IconButton';
import FreecodeAuthModal from 'components/Modals/FreecodeModals/FreecodeAuthModal/FreecodeAuthModal';
import PurchaseCourseModal from 'pages/CoursePage/components/PurchaseCourseModal';
import CourseSignupModal from 'pages/CoursePage/components/CourseSignUpModal';
import { getCourseAccessLevelInformation } from 'functions/getCourseExerciseInformation';
import { CourseTabContent, SyllabusContainer, CourseNameContainer, CourseName, Icon, ModuleContainer } from './styles';

export default function FreecodeCourse() {
  const { exerciseId } = useParams();

  const { user } = useSelector((state) => state.auth);
  const { course, languageData } = useFreecodeContextData();
  const { language } = useFreecodeContextRun();

  const [courseStructure, setCourseStructure] = useState({});
  const [displayAuthModal, setDisplayAuthModal] = useState(false);
  const [displayPurchaseModal, setDisplayPurchaseModal] = useState(false);
  const [displayCourseSignUpModal, setDisplayCourseSignUpModal] = useState(false);
  const [freeCount, setFreeCount] = useState(0);
  const [signInExercises, setSignInExercises] = useState([]);

  const toggleAuthModal = () => setDisplayAuthModal(!displayAuthModal);

  useEffect(() => {
    if (!course?._id) return;
    let courseCopy = JSON.parse(JSON.stringify(course));
    let index = _.findIndex(courseCopy.syllabus, function (lesson) {
      if (lesson.exercise && String(lesson.exercise.id) === String(exerciseId)) return true;
      else {
        let exercises = _.pluck(lesson.modules, 'exercise');
        let exercisesId = _.pluck(exercises, 'id');
        let found = _.find(exercisesId, function (exercise) {
          return String(exercise) === String(exerciseId);
        });
        if (found) return true;
      }
    });
    courseCopy.active = true;
    courseCopy.syllabus[index].active = true;
    setCourseStructure(courseCopy);
  }, [course, exerciseId]);

  useEffect(() => {
    const { freeCount, signInExercises } = getCourseAccessLevelInformation(course);
    setFreeCount(freeCount);
    setSignInExercises(signInExercises);
  }, [course]);

  const setLessonActive = function (index, isCourse) {
    let courseCopy = JSON.parse(JSON.stringify(courseStructure));
    if (isCourse) courseCopy.active = !courseCopy.active;
    else courseCopy.syllabus[index].active = !courseCopy.syllabus[index].active;
    setCourseStructure(courseCopy);
  };

  const checkIsExerciseCompletedInLanguage = (values) =>
    _.every(_.pluck(values, 'isCompleted'), (value) => value === true);

  const renderLessons = (lesson, index) => (
    <FreecodeCourseExpandingItem
      title={lesson.name}
      openDyDefault={lesson.active}
      toggled={() => setLessonActive(index)}
      key={index}
    >
      <SyllabusContainer>
        {lesson.modules.map((module) => {
          const showAuthModal = course.isPaidCourse && !user?._id && ['paid', 'signedIn'].includes(module.accessLevel);
          const showBuyCourseModal = course.isPaidCourse && module.accessLevel === 'paid' && user?._id;

          let icon = checkIsExerciseCompletedInLanguage(module.exercise.languagesCompleted[language], module)
            ? 'fa-regular fa-circle-check'
            : 'fa-regular fa-circle';
          if (course.isPaidCourse) {
            if (module.accessLevel === 'paid') icon = `fa fa-lock pr-2`;
            if (module.accessLevel === 'signedIn' && !user._id) icon = `fa fa-unlock pr-2`;
          }

          return (
            <ModuleContainer
              active={module.exercise.id === exerciseId}
              onClick={() => {
                showAuthModal
                  ? setDisplayCourseSignUpModal(true)
                  : showBuyCourseModal
                    ? setDisplayPurchaseModal(true)
                    : (window.location.href = `/exercise/${module.exercise.id}?courseId=${course._id}`);
              }}
              key={module.exercise.id}
            >
              <Icon icon={icon}></Icon>
              {module.name}
            </ModuleContainer>
          );
        })}
      </SyllabusContainer>
    </FreecodeCourseExpandingItem>
  );

  return (
    <CourseTabContent>
      <CourseNameContainer>
        <CourseName>{`${courseStructure.name} (${languageData[language].SimpleName}) `}</CourseName>
        <RoundIconButtonLink icon="fa fa-external-link" link={`/courses/${course._id}`} />
      </CourseNameContainer>
      {courseStructure.active && (
        <div>{courseStructure.syllabus.map((syllabus, index) => renderLessons(syllabus, index))}</div>
      )}
      {displayAuthModal && <FreecodeAuthModal onCancel={toggleAuthModal} />}
      {displayPurchaseModal && <PurchaseCourseModal course={course} close={() => setDisplayPurchaseModal(false)} />}
      {displayCourseSignUpModal && (
        <CourseSignupModal
          list={[
            `First ${freeCount} modules`,
            `${signInExercises.join(', ')} ${signInExercises.length > 1 ? 'are' : 'is'} available if you sign up`,
          ]}
          onClose={() => setDisplayCourseSignUpModal(false)}
          onSignUp={() => {
            setDisplayCourseSignUpModal(false);
            setDisplayAuthModal(true);
          }}
        />
      )}
    </CourseTabContent>
  );
}
